// new-chatbot-lib/utils/url.ts
export function getCanonicalUrl(path: string): string {
  return `${getAppUrl()}${path.startsWith('/') ? path : `/${path}`}`
}

function getProtocol(isDevelopment: boolean): string {
  return isDevelopment ? 'http://' : 'https://';
}

export function getAppUrl(orgSlug?: string, path?: string): string {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isPreview = process.env.VERCEL_ENV === 'preview';
  const protocol = isDevelopment ? 'http://' : 'https://';
  const baseDomain = process.env.NEXT_PUBLIC_BASE_DOMAIN || 'mixus.ai';

  let baseUrl = '';
  if (isDevelopment) {
    baseUrl = `${protocol}localhost:3000`;
  } else if (isPreview) {
    baseUrl = `${protocol}${process.env.NEXT_PUBLIC_VERCEL_URL}`;
  } else {
    baseUrl = `${protocol}${baseDomain}`;
  }

  // Add organization path if provided
  if (orgSlug) {
    baseUrl += `/organization/${orgSlug}`;
  }

  // Add additional path if provided
  if (path) {
    baseUrl += path.startsWith('/') ? path : `/${path}`;
  }

  return baseUrl;
}

export function getEnvironmentInfo() {
  const vercelEnv = process.env.VERCEL_ENV;
  const isDevelopment = vercelEnv === 'development' || (!vercelEnv && process.env.NODE_ENV === 'development');
  const isPreview = vercelEnv === 'preview';

  return {
    isDevelopment,
    isPreview,
    vercelEnv
  };
}
